import { getSiteName } from '@dustin-web/microsite-config'
import { useI18n } from '../i18n'
import { useSiteContext } from './use-site-context'

export const useSiteTitle = () => {
  const { site } = useSiteContext()
  const { translate } = useI18n()

  const siteName = getSiteName(site)

  const getSiteTitle = (pageTitle: string) => {
    return pageTitle ? `${pageTitle} | ${siteName}` : siteName
  }

  return {
    siteTitle: getSiteTitle(translate(site)),
    getSiteTitle,
  }
}
